import { render, staticRenderFns } from "./ExtraServicesComponent.vue?vue&type=template&id=0b8a2f8c&scoped=true"
import script from "./ExtraServicesComponent.vue?vue&type=script&lang=js"
export * from "./ExtraServicesComponent.vue?vue&type=script&lang=js"
import style0 from "./ExtraServicesComponent.vue?vue&type=style&index=0&id=0b8a2f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a2f8c",
  null
  
)

export default component.exports